module.exports = __webpack_public_path__ + "static/media/mail.bcc8c8a9.svg";